export const SET_RESOURCES = 'Set resources'
export const DELETE_RESOURCE = 'Delete resources'
export const UPDATE_RESOURCE = 'Update resources'
export const SET_SPECIALTIES = 'Set specialties'
export const SET_CATEGORIES = 'Set categories'
export const SET_CODES = 'Set codes'
export const SET_SERVICE_TYPES = 'Set service types'
export const SET_PAYMENT_METHODS = 'Set payment methods'
export const SET_ENCOUNTER_CLASSES = 'Set encounter classes'
export const SET_MARITAL_STATUSES = 'Set marital statuses'
export const SET_MEDICATION_OPTIONS = 'Set medication options'
export const SET_CLINICAL_OPTIONS = 'Set clinical options'
export const SET_ENCOUNTER_STATUSES = 'Set encounter statuses'
export const SET_RELIGIOUS_AFFLIATIONS = 'Set religious affiliation'
export const SET_GENDERS = 'Set genders'
export const SET_OBSERVATION_UNIT_TYPES = 'Set observation unit types'
export const SET_OBSERVATION_INTERPRETATION_TYPES = 'Set observation interpretation types'
export const SET_SYSTEM_EXAM_UNIT_TYPES = 'Set system exam unit types'
export const SET_SOCIAL_HISTORY_UNIT_TYPES = 'Set social history unit types'
export const SET_REFERENCE_TYPES = 'Set reference types'
export const SET_VITALS_UNIT_TYPES = 'Set vitals unit types'
export const SET_LANGUAGES = 'Set languages'
export const SET_DEVICE_TYPES = 'Set device types'
export const SET_VENDORS = 'Set vendors'
export const SET_PHARMACY_INVENTORY_OPTIONS = 'Set pharmacy inventory options'
export const SET_CURRENCIES = 'Set currencies'
export const SET_ENCOUNTER_PRIORITIES = 'Set encounter priorities'
export const SET_OBSERVATION_CATEGORIES = 'Set observation categories'
export const SET_DIAGNOSTIC_LAB_PROCEEDURES = 'Set diagnostic lab proceedures'
export const SET_SERVICE_REQUEST_SECTION_TYPES = 'Set service request section types'
export const SET_SERVICE_REQUEST_CATEGORY_TYPES = 'Set service request category types'
export const SET_SERVICE_GENERIC_PERIOD_UNIT_TYPES = 'Set service generic period unit types'
export const SET_DOSAGE_ROUTES = 'Set Dosage routes'
export const SET_REVENUE_TAGS = 'Set Revenue tags'